module.exports = __webpack_public_path__ + "img/category-etc.d5eaa1a6.svg";